import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InventoryCommonApi } from '../../api/transaction/inventory-common-api.api';
import { CommonInventoryData } from '../../interface/transaction/item-scrap-entry';

@Injectable()
export class InventoryCommonService  extends  CommonInventoryData {

  constructor(private api:InventoryCommonApi) {
    super();
  }

  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  listAssessmentCategoryMst(url: string,tenantId:string): Observable<any> {
    return this.api.listAssessmentCategoryMst(url,tenantId);
  }

  loadRiskAssesTransMst(url: string , det): Observable<any> {
    return this.api.riskAssessmentTransMst(url , det);
  }

  getById(url:string): Observable<any>{
    return this.api.getById(url);
  }


  create(url: string, data:any): Observable<any> {
    return this.api.create(url,data);
  }

  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

  updateAssessmentCategoryMst(url: string, data:any,id: number, shouldReturn: boolean): Observable<any> {
    return this.api.updateAssessmentCategoryMst(url,data,id,shouldReturn);
  }
  createAssessmentCategoryMst(url: string, data:any,shouldReturn: boolean): Observable<any> {
    return this.api.createAssessmentCategoryMst(url,data,shouldReturn);
  }

  searchwithParams(url: string, det:any, data: any): Observable<any> {
    return this.api.searchApi(url,det,data);
  }

  updateProduct(url: string , det:any): Observable<any> {
    return this.api.updateProduct(url,det);
  }

  updateProductList(url: string , det:any): Observable<any> {
    return this.api.updateProducts(url,det);
  }
  
   updated(url: string ,det:any): Observable<any> {
    return this.api.updated(url,det);
  }
  
  updatedtrans(url: string ,det:any): Observable<any> {
    return this.api.updated(url,det);
  }

  vopdlist(url: string ,options:any): Observable<any> {
    return this.api.vopdlist(url,options);
  }

  vopdAppPut(url: string ,options:any): Observable<any> {
    return this.api.vopdAppPut(url,options);
  }
  vopd(url:string,options:any): Observable<any> {
    return this.api.vopd(url,options);
  }
  vopdAppGet(url:string,options:any): Observable<any> {
    return this.api.vopdAppGet(url,options);
  }
  vopdOrgGet(url:string,options:any): Observable<any> {
    return this.api.vopdOrgGet(url,options);
  }
 
  vopdSessionGet(url:string,options:any): Observable<any> {
    return this.api.vopdSessionGet(url,options);
  }
  vopdUpdate(url:string,data): Observable<any> {
    return this.api.vopdUpdate(url,data);
  }
}
